import { AuthenticationMethodType, AuthenticationStatus } from '@mc-alberta/types';
import { STRATEGIES } from '../constants';
/**
 * Return if the authentication status is a fatal status
 */
export function isFatalStatus(authenticationStatus) {
    switch (authenticationStatus) {
        case AuthenticationStatus.NOT_SUPPORTED:
        case AuthenticationStatus.CHALLENGE_FAILED:
        case AuthenticationStatus.CANCELLED:
        case AuthenticationStatus.EXPIRED:
            return true;
        default:
            return false;
    }
}
/**
 * Returns the strategy of the given authentication method type.
 */
export function getStrategyByType(type) {
    return STRATEGIES.find(({ types }) => types.includes(type));
}
/**
 * Returns a list of authentication method types belonging to the given strategy.
 */
export function getTypesByStrategy(strategy) {
    var _a;
    return ((_a = STRATEGIES
        .find(record => record.strategy === strategy)) === null || _a === void 0 ? void 0 : _a.types) || [];
}
/**
 * Returns the card token that can be used for `x-src-card-token` headers in MACS calls.
 * This will validate that `cardId` is present in the JWT payload and that it is base64-decoded.
 *
 * @param assuranceData - assurance data generated from a successful auth session
 * @param existingCardToken - the current card token (if any)
 */
export function getCardToken(assuranceData, existingCardToken) {
    var _a, _b;
    const token = (_b = (_a = assuranceData === null || assuranceData === void 0 ? void 0 : assuranceData.verificationData) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.additionalData;
    if (token) {
        try {
            // tokens which can be used for `x-src-card-token` must always be plain JWTs
            const decoded = (() => {
                try {
                    const value = atob(token);
                    return value;
                }
                catch (_) {
                    return token;
                }
            })();
            // ensure that the `cardId` parameter is present in the JWT payload
            const payload = JSON.parse(atob(decoded.split('.')[1]));
            if (payload.cardId) {
                return decoded;
            }
        }
        catch (_) {
            // if it's not base64, then it's an assertion for an external MFA method
            // and therefore it does not apply to `x-src-card-token`
            return existingCardToken;
        }
    }
    return existingCardToken;
}
export function getLookupKpiMeta(authenticationMethods) {
    var _a, _b, _c, _d, _e, _f;
    const hasType = (type) => authenticationMethods.some(method => method.authenticationMethodType === type);
    const consentSMSAuthVerificationSupported = hasType(AuthenticationMethodType.SMS_OTP);
    const consentEMAILAuthVerificationSupported = hasType(AuthenticationMethodType.EMAIL_OTP);
    const fidoMethod = authenticationMethods.find(method => method.authenticationMethodType === AuthenticationMethodType.FIDO2);
    return {
        cardData: {
            cardVerificationData: {
                lvlrAuthVerificationSupported: hasType(AuthenticationMethodType.LVLR),
                fidoAuthVerificationSupported: hasType(AuthenticationMethodType.FIDO2),
                threeDsAuthVerificationSupported: hasType(AuthenticationMethodType.THREE_DS),
                consentAuthVerificationSupported: consentEMAILAuthVerificationSupported || consentSMSAuthVerificationSupported,
                consentSMSAuthVerificationSupported,
                consentEMAILAuthVerificationSupported
            }
        },
        authenticationData: {
            multiFactorAuthenticatorData: {
                dasAuthenticationSessionId: (_b = (_a = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _a === void 0 ? void 0 : _a.extAuthProviderMetaData) === null || _b === void 0 ? void 0 : _b.authSessionId,
                dasClientId: (_d = (_c = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _c === void 0 ? void 0 : _c.extAuthProviderMetaData) === null || _d === void 0 ? void 0 : _d.clientId,
                isSupressIDV: (_f = (_e = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _e === void 0 ? void 0 : _e.extAuthProviderMetaData) === null || _f === void 0 ? void 0 : _f.isSuppressIDV
            }
        }
    };
}
//# sourceMappingURL=utils.js.map